module.exports = __webpack_public_path__ + "img/empty.0230c5f4.webp";